import {combineReducers} from 'redux';
import types from './types';

// 写真情報 情報
const photoInfo = (state = null, action) => {
  switch (action.type) {
    case types.GET_PHOTO_INFO:
      return action.photoInfo;
    default:
      return state;
  }
};

const reducer = combineReducers({
  photoInfo,
});

export default reducer;
